export default [
    {
        path: '/diagnosis/index-details',
        name: 'diagnosisDetails',
        meta: {
            index: 2,
            title: '经营诊断'
        },
        component: () => import('@/views/diagnosis/index-details.vue')
    }
]
